import React, { useEffect, useState } from "react";
import "./../css/benchmark.scss";

const Benchmark: React.FC<{ 
  option?: string; 
  blockingAction?: () => void; 
  unblockingAction?: () => void 
}> = ({ option, blockingAction, unblockingAction }) => {
  const [status, setStatus] = useState("Initializing hardware telemetry...");
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (option === "benchmark") {
      if (blockingAction) blockingAction();

      const intervals = [
        { time: 500, msg: "Connecting to local hardware (NVIDIA Jetson)...", prog: 20 },
        { time: 1000, msg: "Bypassing cloud abstractions...", prog: 50 },
        { time: 1500, msg: "Optimizing TensorRT engines...", prog: 80 },
        { time: 2000, msg: "Result: Standard cloud abstractions destroyed. Efficiency increased by 40%.", prog: 100 },
      ];

      intervals.forEach((step, i) => {
        setTimeout(() => {
          setStatus(step.msg);
          setProgress(step.prog);
          if (i === intervals.length - 1 && unblockingAction) {
            unblockingAction();
          }
        }, step.time);
      });
    } else {
      setStatus("Usage: run --benchmark");
    }
  }, [option, blockingAction, unblockingAction]);

  return (
    <div className="benchmark-container">
      <div className="status-message">{status}</div>
      {option === "benchmark" && (
        <div className="progress">
          <div
            className="progress-bar bg-success"
            role="progressbar"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default Benchmark;
